import { createAction } from '../../utils/helpers';
import * as actionTypes from './types';

export const addToGroup = createAction(actionTypes.ADD_TO_GROUP);
